module.exports = __webpack_public_path__ + "img/40_38_054_360.e6142cfa.jpg";